import { periodColumn } from 'components/columns';
import { BoundStates, CampaignWidget, ClientTitle } from 'components';
import { sepFormat } from 'utilities';
import type { ListCampaign } from 'modules/campaign/campaign/types';
import { TableColumns } from '@ff-it/ui';
import { CampaignStateTag } from 'modules/campaign/status/CampaignStateTag';

const sumProps = {
  width: 100,
  cellProps: {
    textAlign: 'end' as const,
    className: 'px-1',
  },
};

export const columns: TableColumns<ListCampaign> = [
  {
    content: 'Campaing',
    key: 'number',
    minWidth: 150,
    cellProps: { className: 'py-1' },
    render: (campaign: ListCampaign) => <CampaignWidget {...campaign} link target="_self" />,
    sortable: true,
  },
  {
    content: 'State',
    width: 100,
    cellProps: {
      flush: true,
      textAlign: 'left',
    },
    key: 'sums.state',
    sortable: true,
    render: ({ sums: { state } }) => <CampaignStateTag state={state} appearance="naked" />,
  },
  {
    cellProps: {
      className: 'py-1',
    },
    content: 'Client',
    key: 'related_client_title',
    render: ClientTitle,
    sortable: true,
  },
  periodColumn,
  {
    ...sumProps,
    content: 'Income',
    key: 'sums.income_total',
    render: ({ sums: { income_total, state } }) => (state !== 'CANCELED' ? sepFormat(income_total) : null),
    sortable: true,
  },
  {
    ...sumProps,
    content: 'Expense',
    key: 'sums.expense_total',
    render: ({ sums: { expense_total, state } }) => (state !== 'CANCELED' ? sepFormat(expense_total) : null),
    sortable: true,
  },

  {
    ...sumProps,
    content: 'Revenue',
    key: 'sums.revenue',
    sortable: true,
    render: ({ sums: { revenue, state } }) => (state !== 'CANCELED' ? sepFormat(revenue) : null),
  },
  {
    width: 40,
    cellProps: {
      flush: true,
      textAlign: 'center',
      className: 'pr-0',
    },
    key: 'sums',
    render: ({ sums }: ListCampaign) => (sums.state !== 'CANCELED' ? <BoundStates {...sums} /> : null),
  },
];
